import React, { Component } from 'react';
import { Row, Spin, DatePicker, Button } from 'antd';
import moment from 'moment';
import { inject, observer } from "mobx-react";
import { defaultData } from "../1.1/data";
import "./index.scss";

const { MonthPicker } = DatePicker;

@inject('store')
@observer
class index extends Component {
    state = {
        date: moment().subtract(1, 'month').format('YYYY-MM'),
        data: [],
        loading: true,
        select: {
            room: "房型一",
            type: "携程"
        }
    }

    componentDidMount() {
        this.getDateData(this.state.date);
    }


    onChange = (name, value) => {
        let select = this.state.select;
        select[name] = value;
        this.setState({ select });
    }

    getDateData = (date) => {
        const year = moment(date).format('YYYY');
        const month = moment(date).format('M');

        fetch(`/getPriceRepairing?year=${year}&month=${month}`, { credentials: 'include' }).then(x => x.json()).then(x => {
            let data = JSON.parse(JSON.stringify(defaultData));
            if (x.data && x.data.length > 0) {
                data = x.data;
            }
            this.setState({ loading: false, data });

        }).catch(err => {
            this.setState({ loading: false });
            console.error(err);
        })
    }

    render() {
        const { data, select } = this.state; 
        return (
            <Spin spinning={this.state.loading}>
                <div className="table7_1_1 price-visual-diagram">
                    <Row className="title" id="table4_1_1"  >
                        <Row>1.2  Price Repairing Visual Diagram 官网比价可视化</Row>
                        <Row className="table-month">
                            <MonthPicker
                                placeholder="请选择年月"
                                monthCellContentRender={(date, local) => {
                                    return moment(date).format('M月')
                                }}
                                defaultValue={moment(this.state.date, "YYYY-MM")}
                                format="YYYY-MM"
                                onChange={(date, str) => {
                                    this.setState({
                                        date: str,
                                        data: [],
                                        loading: true
                                    });
                                    this.getDateData(str)
                                }}
                            />
                        </Row>
                    </Row>

                    <div className="price-content">
                        <div className="select-type">
                            <Button
                                type="primary"
                                ghost={select.type != "携程"}
                                onClick={() => this.onChange('type', '携程')}
                            >
                                携程
                            </Button>
                            <Button
                                type="primary"
                                ghost={select.type != "美团"}
                                onClick={() => this.onChange('type', "美团")}
                            >
                                美团
                            </Button>
                            <Button
                                type="primary"
                                ghost={select.type != "温德姆中文"}
                                onClick={() => this.onChange('type', "温德姆中文")}
                            >
                                温德姆中文
                            </Button>
                            <Button
                                type="primary"
                                ghost={select.type != "温德姆英文"}
                                onClick={() => this.onChange('type', "温德姆英文")}
                            >
                                温德姆英文
                            </Button>
                        </div>
                        <div className="select-type">
                            <Button
                                type="primary"
                                ghost={select.room != "房型一"}
                                onClick={() => this.onChange('room', "房型一")}
                            >
                                房型一
                            </Button>
                            <Button
                                type="primary"
                                ghost={select.room != "房型二"}
                                onClick={() => this.onChange('room', "房型二")}
                            >
                                房型二
                            </Button>
                        </div>
                    </div>

                    <div className="list">
                        {
                            ['day2', 'day3', 'day4', 'day5', 'day6', 'day7'].map((name, i) => {
                                const item = data.find(v => v.name == select.type && v.room_type == select.room) || {};
                                const websiteData = data.find(v => v.room_type == select.room && v.name == "GCH官网") || {};
                                let className = '';
                                if (websiteData[name] > item[name]) className = 'red';
                                if (websiteData[name] == item[name]) className = 'yellow'; 
                                return (
                                    <div className={`item ${className}`} key={name}>
                                        <div className="day">
                                            {i + 1}<span>th</span> day
                                    </div>
                                        <div>
                                            <span>{websiteData[name] || 0}</span>
                                            <span>{item[name] || 0}</span>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
            </Spin >
        );
    }
}

export default index;



// WEBPACK FOOTER //
// ./src/components/otherHeadquartersForms/price/1.2/index.js